module.exports = __webpack_public_path__ + "public/images/employee-eye-closed.b01c21bb66badfa81d852cfcfbc96e45.svg";